// extracted by mini-css-extract-plugin
export default {"infoRow":"InfoRow_infoRow__y13E0","label":"InfoRow_label__Be7J-","value":"InfoRow_value__J5at-"};